module.exports = __webpack_public_path__ + "media/operational-planning_de_desktop.fc7370fa.webm";